import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as assetApi from '../../../../api/assets';

const useCreateAsset = () => {
    const queryClient = useQueryClient();
    const queryKey = ['asset', 'photos'];

    return  useMutation({
        mutationFn: assetApi.createAsset,
        onError: (error) => {
            console.log(error);
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey,
            });
        }
    });
};

export { useCreateAsset };